import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleUser, faMaximize, faMinimize, faRightFromBracket, faUser } from "@fortawesome/free-solid-svg-icons";
import ilens_logo from "../../../src/shared/images/ilens-white.png";
import './Header.scss';
import classNames from 'classnames';
import { useSharedState } from "../services/WindowSizeService";
import { IHeaderProps } from "./Interfaces";
import { Collapse } from "bootstrap";
import { useEffect } from "react";
import { sessionService } from "../../shared/Utils/SessionService";
import { authorizationService } from "../../shared/api_services/authorizationService";
import { endSession, noAccessMessage } from "../../shared/Utils/Utils";
declare global {
    interface Document {
        mozCancelFullScreen?: () => Promise<void>;
        msExitFullscreen?: () => Promise<void>;
        webkitExitFullscreen?: () => Promise<void>;
        mozFullScreenElement?: Element;
        msFullscreenElement?: Element;
        webkitFullscreenElement?: Element;
    }

    interface HTMLElement {
        msRequestFullscreen?: () => Promise<void>;
        mozRequestFullscreen?: () => Promise<void>;
        webkitRequestFullscreen?: () => Promise<void>;
    }
}
const Header = (props: IHeaderProps) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { setIsMenuOpen, isMenuOpen, headerFlag } = props;
    const windowSize$ = useSharedState();
    const desktopView = ["xxl", "xl", "lg"].includes(windowSize$) ? true : false;
    const userDetails: any = sessionService.getDecryptedSession();


    // Functionality to logout on selecting logout option from header
    const userLogout = async () => {
        let payload: any = {
        }
        if (userDetails?.user_id) {
            payload["user_id"] = userDetails?.user_id;
        }
        else {
            payload["logout_type"] = "general_logout";
        }
        try {
            return await authorizationService.logout("Logout", payload).then((res: any) => {
                if (res.status === 200) {
                    if (res.body) {
                        endSession()
                    }
                }
                else if (res.response?.status === 401) {
                    endSession()
                }
                else if (res.response?.status === 403) {
                    noAccessMessage(res.response?.data?.message)
                }
                else {
                    console.log("error");
                }
            })
        } catch (err: any) {
            console.log(err);
        }
    }


    const onClickLogOut = () => {
        userLogout();
    }

    // Navigate to home page
    const goToHome = () => {
        window.location.reload();
    }

    // full screen view and normal screen view
    function toggleFullScreen() {
        let elem = document.documentElement;
        if ((document.fullscreenElement !== undefined && document.fullscreenElement === null) || (document.msFullscreenElement !== undefined && document.msFullscreenElement === null)) {
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.webkitRequestFullscreen) { /* Safari */
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) { /* IE11 */
                elem.msRequestFullscreen();
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) { /* Safari */
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { /* IE11 */
                document.msExitFullscreen();
            }
        }
    }


    // Header on load functionalities
    useEffect(() => {
        const collapseTriggerList = [].slice.call(document.querySelectorAll('[data-toggle = "collapse"]'))
        collapseTriggerList.map(function (collapseTriggerEl) {
            return new Collapse(collapseTriggerEl)
        });
    }, [])

    return (
        desktopView ? (
            <header className="app-header app-header-dark">
                <div className="d-flex align-items-center app-header-content dis">
                    <div className="header-text mx-0 mx-sm-4 mx-md-4 mx-lg-4 mx-xl-4 mx-xxl-4 my-4" onClick={goToHome}>
                        <img src={ilens_logo} className="logo" alt="Data Logger" />
                        <span className="text-white ilens-logo">Data Logger</span>
                    </div>


                    <div className="top-bar-item top-bar-item-right dis">
                        {/* User profile section */}
                        <div className='dropdown d-flex min-drop-width' >
                            <div onClick={() => { toggleFullScreen() }} className="center-align">
                                <span className="fs-18 header-icon py-3 px-2">
                                    <FontAwesomeIcon data-toggle="tooltip" data-placement="bottom" title="Compress" icon={faMinimize} className="mx-2 minimize-icon" />
                                    <FontAwesomeIcon data-toggle="tooltip" data-placement="bottom" title="Enlarge" icon={faMaximize} className="mx-2 maximize-icon" />
                                </span>
                            </div>
                            <button className="btn-account d-none d-md-flex d-md-align-items-center" onClick={setIsMenuOpen}>
                                {
                                    userDetails?.["pic_url"] ?
                                        <>
                                            <img className="user-image" src={userDetails?.["pic_url"]} alt="User Data" referrerPolicy="no-referrer" />
                                        </> :
                                        <FontAwesomeIcon icon={faUser} size="2x" />
                                }
                                <span className="account-summary pr-md-4 text-white mt-1 ml-2">
                                    {userDetails?.["name"]
                                        ?
                                        <span className="account-name">
                                            {userDetails?.["name"]}
                                        </span>
                                        :
                                        <span className="account-name">
                                            User
                                        </span>
                                    }
                                    {userDetails?.["user_role"]
                                        ?
                                        <span className="account-description">
                                            {userDetails?.["user_role"]}
                                        </span>
                                        :
                                        <span className="account-description">
                                            User Role
                                        </span>
                                    }
                                </span>
                            </button>

                            {/* Menu dropdown which lists the action items */}
                            {isMenuOpen &&
                                <div className="dropdown-menu show" style={{ position: "absolute", top: "45px", left: "-70px", willChange: "top, left", width: "22rem" }} x-placement="bottom-end">
                                    <div className="list-group-item">
                                        <div className="list-group-item-figure">
                                            {
                                                userDetails?.["pic_url"] ?
                                                    <>
                                                        <img className="user-image-modal" src={userDetails?.["pic_url"]} alt="User Data" referrerPolicy="no-referrer" />
                                                    </> :
                                                    <FontAwesomeIcon className="user-image-modal" icon={faCircleUser} size="4x" width="50px" />
                                            }
                                        </div>
                                        <div className="list-group-item-body">
                                            <h4 className="list-group-item-title">
                                                {userDetails?.["name"]
                                                    ?
                                                    <span>
                                                        {userDetails?.["name"]}
                                                    </span>
                                                    :
                                                    <>
                                                        User Name
                                                    </>
                                                }
                                            </h4>
                                            <p className="list-group-item-text"> {userDetails?.["email"]
                                                ?
                                                <span className="ellipsis-class">
                                                    {userDetails?.["email"]}
                                                </span>
                                                :
                                                <>
                                                    User Email
                                                </>
                                            } </p>
                                        </div>
                                        <div className="list-group-item-figure">
                                            <button className="btn btn-sm btn-icon btn-light"><i className="oi oi-data-transfer-download"></i></button>
                                        </div>
                                    </div>
                                    <div className="dropdown-divider"></div>
                                    <div className={classNames("menu-link menu-link-hoverable pointer")} onClick={() => { onClickLogOut() }} attr-test="logout">
                                        <span >
                                            <FontAwesomeIcon icon={faRightFromBracket} className="mx-2 side-menu-label" />
                                        </span>
                                        <span className='side-menu-label'>Logout</span>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </header>
        )
            :
            <header className="app-header app-header-dark ">

                <div className="d-flex align-items-center justify-content-between app-header-content">
                    <div className="header-text mx-0 mx-sm-4 mx-md-4 mx-lg-4 mx-xl-4 mx-xxl-4" onClick={goToHome}>
                        <img src={ilens_logo} className="logo" alt="" />
                    </div>
                    <div className="top-bar-item top-bar-item-right">
                        <div className="avatar-button-class">
                            <button className="navbar-toggler btn-account" data-toggle="collapse" data-target="#collapseProfile">
                                {
                                    userDetails?.["pic_url"] ?
                                        <div className="color-white" onClick={setIsMenuOpen}>
                                            <img className="user-image" src={userDetails?.["pic_url"]} alt="User Data" referrerPolicy="no-referrer" />
                                        </div> :
                                        <FontAwesomeIcon icon={faUser} onClick={setIsMenuOpen} />
                                }
                            </button>
                        </div>
                    </div>
                </div>
                {isMenuOpen &&
                    <div
                        className={classNames("collapse navbar-collapse", {
                            // "show": isMenuOpen,
                        })}
                        id="collapseProfile">
                        <div className="list-group-item">
                            <div className="list-group-item-figure hello">
                                {
                                    userDetails?.["pic_url"] ?
                                        <>
                                            <img className="user-image-modal" src={userDetails?.["pic_url"]} alt="User Data" referrerPolicy="no-referrer" />
                                        </>
                                        :
                                        <FontAwesomeIcon icon={faCircleUser} size="2x" width="50px" />
                                }
                            </div>
                            <div className="list-group-item-body">
                                <h4 className="list-group-item-title">
                                    {userDetails?.["name"]
                                        ?
                                        <span>
                                            {userDetails?.["name"]}
                                        </span>
                                        :
                                        <>
                                            User
                                        </>
                                    }
                                </h4>
                                <p className="list-group-item-text"> {userDetails?.["user_role"]
                                    ?
                                    <span>
                                        {userDetails?.["user_role"]}
                                    </span>
                                    :
                                    <>
                                        User Role
                                    </>
                                } </p>
                            </div>
                            <div className="list-group-item-figure hiiii">
                                <button className="btn btn-sm btn-icon btn-light">
                                    <i className="oi oi-data-transfer-download"></i>
                                </button>
                            </div>
                        </div>
                        <div className="dropdown-divider"></div>
                        <div className="menu-link menu-link-hoverable menu-link-mob" onClick={() => { onClickLogOut() }} attr-test="logout">
                            <span ><FontAwesomeIcon icon={faRightFromBracket} className="mx-2 side-menu-label" /></span>
                            <span className='side-menu-label'>Logout</span>
                        </div>
                    </div>
                }
            </header>
    )
}

export default Header;